export default __webpack_public_path__ + "static/media/autodrive_pause_circle.f6f4a5a4.svg";